import { useState } from 'react';
import { followUser, unfollowUser } from '../socialApi';

type FollowButtonProps = {
  userId: string;
  initialFollowing: boolean;
  size?: 'small' | 'default';
  onChanged?: (following: boolean) => void;
};

export function FollowButton({ userId, initialFollowing, size = 'default', onChanged }: FollowButtonProps) {
  const [following, setFollowing] = useState(initialFollowing);
  const [loading, setLoading] = useState(false);

  const toggle = async () => {
    if (loading) return;
    const next = !following;
    setFollowing(next);
    setLoading(true);
    onChanged?.(next);

    try {
      if (next) {
        await followUser(userId);
      } else {
        await unfollowUser(userId);
      }
    } catch {
      setFollowing(!next);
      onChanged?.(!next);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      className={`follow-button ${following ? 'is-following' : ''} ${size === 'small' ? 'is-small' : ''}`}
      type="button"
      disabled={loading}
      aria-busy={loading}
      onClick={() => void toggle()}
    >
      {loading ? 'Сохраняем…' : following ? 'Отписаться' : 'Подписаться'}
    </button>
  );
}
